import { ApiResponse, CustomQueryResponse } from "../../../../model/common/apiResponse";
import { axiosService, ServiceEndPoint } from "../../../../Services/common/Axios.service";
import { Order } from "../model/order.model";

const SERVICE_URL=ServiceEndPoint.outbound_service;

export function recordCounts(status: string[],searchTerm:string,filterPayload:any,search_columns:any) {
  return {
    columns: [
      {
        data: "sales_order.order_number",
        func: "count",
        as: "order_count"
      }
    ],
    search_columns:search_columns,
    conditions: [ ...filterPayload,
      ["sales_order.status", "in", status]
    ],
    "search": searchTerm,
    
    limit: -1
  }
}

export async function submitOrderForm(payload:any): Promise<ApiResponse<any>> {
    const response = await axiosService.post(`${SERVICE_URL}sales-orders`,payload);
    return response.data;
}

export async function updateOrderForm(payload:any,id?:string): Promise<ApiResponse<any>> {
  const response = await axiosService.put(`${SERVICE_URL}sales-orders/${id}`,payload);
  return response.data;
}

export async function getOrderDetailsById(id?:string): Promise<ApiResponse<Order>> {
  const response = await axiosService.get(`${SERVICE_URL}sales-orders/${id}`);
  return response.data;
}

export async function fetchOrderList(page?: number,payload?:any): Promise<ApiResponse<CustomQueryResponse<any>>> {
       const response = await axiosService.post(`${SERVICE_URL}sales-orders/query`,payload);
       return response.data;
}

export async function fetchStatusWiseCounts(statuses:string[],searchTerm:string,filterPayload:any,search_columns:any): Promise<ApiResponse<any[]>> {
    const responses = await Promise.all(
        statuses.map(status => 
            axiosService.post(`${SERVICE_URL}sales-orders/query`, recordCounts([status],searchTerm,filterPayload,search_columns))
        )
    );
    const result = responses.reduce((acc: any, response, index) => {
        acc[statuses[index]] = response.data?.data?.results[0].order_count || 0;
        return acc;
    }, {});
    return { data: result };
}
export async function getByOrderId(id:string): Promise<ApiResponse<any>> {
  const response = await axiosService.get(`${SERVICE_URL}sales-orders/${id}`);
  return response.data;
}
export async function getByOrderIdForEdit(id:string): Promise<ApiResponse<any>> {
  const response = await axiosService.get(`${SERVICE_URL}sales-orders/${id}/for-update`);
  return response.data;
}
export async function deleteOrderById(id:string): Promise<ApiResponse<any>> {
  const response = await axiosService.delete(`${SERVICE_URL}sales-orders/${id}`);
  return response.data;
}
export async function deleteOrderLineItem(id:string,line_id:string): Promise<ApiResponse<any>> {
  const response = await axiosService.delete(`${SERVICE_URL}sales-orders/${id}/line/${line_id}`);
  return response.data;
}
export async function fetchSubTabStatusWiseCounts(): Promise<ApiResponse<any>> {
  const response = await axiosService.get(`${SERVICE_URL}sales-orders/counts/by-status`);
  return response.data;
}

export async function deallocateOrderById(id:number): Promise<ApiResponse<any>> {
  const response = await axiosService.get(`${SERVICE_URL}sales-orders/deallocate-sales-order/${id}`);
  return response.data;
}